<template>
  <main>
    <div class="container-fluid devoir">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template #right-element>
              <router-link :to="{name: 'AjoutDm'}" class="btn button btn-primary" :disabled="!loading">
                <i class="icon-Add" />
                {{ $t("button.addDM") }}
              </router-link>
            </template>
            <template #left-element>
              <h3>{{ $t("title.listDevoir") }} ({{ total }})</h3>
            </template>
          </TopTemplate>
        </div>
      </div>

      <!-- :dropdown-should-open="() => true" -->

      <div class="ajout-container row bloc">
        <div class="row container-select container-filter">
          <div v-if="selectedLevel" class="col-md-12">
            <div class="reset_student" @click="resetFilter()">
              <i class="icon-reset" />
              {{ $t("barFiltre.renitialiser") }}
            </div>
          </div>
          <div class="col-md-4 col-12 select-wrapper bloc-title">
            <div>
              <span class="title-select">{{ $t("barFiltre.niveau") }}</span>
            </div>
            <div>
              <v-select
                v-model="selectedLevel"
                :searchable="true"
                :options="levels"
                label="name"
                class="form-control"
                :reduce="(option) => option"
                @update:modelValue="ChangeLevel($event)"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearshType") }}
                  </div>

                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4 col-12 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.classe") }}</span>
            <div>
              <v-select
                v-model="selectedClass"
                :options="classes"
                label="name"
                :searchable="true"
                :disabled="!selectedLevel || selectedLevel.length === 0"
                :reduce="(option) => option"
                class="form-control"
                @update:modelValue="ChangeClass($event)"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearchClasse") }}
                  </div>

                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4 col-12 select-wrapper">
            <span class="title-select">{{ $t("barFiltre.course") }}</span>
            <div />
            <div>
              <v-select
                v-model="selectedCourse"
                :searchable="true"
                :options="courses"
                label="name"
                :disabled="!selectedClass"
                :reduce="(option) => option"
                multiple
                @update:modelValue="ChangeCourse($event)"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearchCourse") }}
                  </div>

                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="general-info-class homeworks-blocs stat row justify-content-center">
        <div class="col-md-4 select-wrapper paragraph bloc-title">
          <div>
            <i class="icon-devoir" />
          </div>
          <div>
            <h3 class="mat">
              {{ total }}
            </h3>
            <!-- <hr/> -->
            <p>{{ $t("barStatic.devoir") }}</p>
          </div>
        </div>

        <div class="col-md-4 select-wrapper bloc-title">
          <div>
            <i class="icon-devoir-termine" />
          </div>
          <div>
            <h3 class="mat">
              {{ totalTermine }}
            </h3>
            <p class="termine">{{ $t("barStatic.etatDone") }}</p>
          </div>
        </div>
        <div class="col-md-4 select-wrapper item-en-cours bloc-title">
          <div>
            <i class="icon-devoir-en-cours" disabled />
          </div>
          <div>
            <h3 class="mat">
              {{ total - totalTermine }}
            </h3>
            <p class="unique">{{ $t("barStatic.etatEncour") }}</p>
          </div>
        </div>
      </div>

      <div class="ajout-container__table row">
        <div class="col-md-12 devoir-maison">
          <div v-if="loading" class="card text-center d-block pt-4 pb-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-if="!loading && devoirs.length == 0" class="card">
            <div class="col-12 empty-result text-center pt-3">
              <p><i class="icon-file-01" /> {{ $t("common.emptysearsh") }}</p>
            </div>
          </div>
          <div v-if="!loading && devoirs.length > 0" class="table">
            <div class>
              <div class="row">
                <div class="col-md-12">
                  <div class="table__wrapper dm_table">
                    <table>
                      <thead>
                        <tr>
                          <th class="classe">
                            <div class="d-inline" @click="sortB('class.type')">
                              {{ $t("devoir.tabDM.Expediteur") }}
                            </div>
                            <div class="icon-wrapper">
                              <i
                                class="ri-arrow-up-s-line"
                                :class="[params.order === null && params.sort === '' ? '' : params.sort === 'class.type' ? (params.order === false ? 'ordredA' : 'ordredD') : '']"
                                @click="sort(false, 'class.type')"
                              />
                              <i
                                class="ri-arrow-down-s-line"
                                :class="[params.order === null && params.sort === '' ? '' : params.sort === 'class.type' ? (params.order === false ? 'ordredD' : 'ordredA') : '']"
                                @click="sort(true, 'class.type')"
                              />
                            </div>
                          </th>
                          <th class="classe">
                            <div class="d-inline">
                              {{ $t("devoir.tabDM.destinataire") }}
                            </div>
                            <div class="icon-wrapper" @click="sortB('class.name')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('class.name', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('class.name', true)]" />
                            </div>
                          </th>
                          <th class="matiere">
                            <div class="d-inline">
                              {{ $t("devoir.tabDM.course") }}
                            </div>
                            <div class="icon-wrapper" @click="sortB('course.name')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('course.name', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('course.name', true)]" />
                            </div>
                          </th>
                          <th class="dm">
                            <div class="d-inline">
                              {{ $t("devoir.tabDM.dm") }}
                            </div>
                            <div class="icon-wrapper" @click="sortB('description')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('description', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('description', true)]" />
                            </div>
                          </th>
                          <th class="pour">
                            <div class="d-inline">
                              {{ $t("devoir.tabDM.pourLe") }}
                            </div>
                            <div class="icon-wrapper" @click="sortB('due_date')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('due_date', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('due_date', true)]" />
                            </div>
                          </th>
                          <!--<th>Statut</th>-->
                          <!--    <th class="par">
                            <div class="d-inline">{{ $t('devoir.tabDM.hasCreated') }}</div>
                            <div class="icon-wrapper" @click="sortB('createdBy.first_name')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('createdBy.first_name', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('createdBy.first_name', true)]" />
                            </div>
                          </th> -->
                          <th class>
                            <div class="d-inline">
                              {{ $t("devoir.tabDM.dateCreated") }}
                            </div>
                            <div class="icon-wrapper" @click="sortB('created_at')">
                              <i class="ri-arrow-up-s-line" :class="[specTri('created_at', false)]" />
                              <i class="ri-arrow-down-s-line" :class="[specTri('created_at', true)]" />
                            </div>
                          </th>
                          <th>{{ $t("common.action") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(devoir, index) in devoirs" :key="index">
                          <!-- <td>
                                                        <label
                                                            class="container-checkbox"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                v-model="
                                                                    selected
                                                                "
                                                                :value="
                                                                    devoir.id
                                                                "
                                                            />
                                                            <span
                                                                class="checkmark"
                                                            ></span>
                                                        </label>
                          </td>-->
                          <td class @click="devoir.collapsed = !devoir.collapsed">
                            <span v-if="devoir.files?.length > 0"><i class="icon-file-04"></i></span>
                            <!--{{ devoir.type.name.name }} -->
                            {{ devoir.createdBy.first_name }}
                            {{ devoir.createdBy.last_name }}
                          </td>
                          <td class="name-classe" @click="devoir.collapsed = !devoir.collapsed">
                            <span>{{ studentDM(devoir) }}</span>
                            <!--  <span v-if="devoir.homework_type === STUDENT_HOMEWORK"><span class="lastName_propre">{{devoir.students_list[0].last_name}}&nbsp;</span><span class="name_propre">{{ devoir.students_list[0].first_name }}</span> ,...</span>
                            <span v-else-if="devoir.homework_type === CLASS_HOMEWORK">{{ devoir.class.name }}</span> -->
                          </td>
                          <td class="name-matiere" @click="devoir.collapsed = !devoir.collapsed">
                            {{ devoir.course.name }}
                          </td>
                          <td
                            :class="{
                              'arabic-text': checkLanguag(devoir.description),
                            }"
                            class="name-description text-message"
                            @click="devoir.collapsed = !devoir.collapsed"
                          >
                            <div :class="[devoir.collapsed ? 'open-text' : 'closed-text']">
                              <p class="table-desc content-editor item-content-msg" v-html="devoir.description"></p>
                            </div>
                          </td>
                          <td class="name-pour" @click="devoir.collapsed = !devoir.collapsed">
                            {{ moment(devoir.due_date).format("DD-MM-YYYY") }}
                          </td>
                          <!--<td :class=" [devoir.Statut == 'Active' ? 'active-style' :'brouillon-style']"  class="primarystyle"><span>{{ devoir.Statut }}</span></td>-->
                          <!--   <td class="name-par" @click="devoir.collapsed = !devoir.collapsed">{{ devoir.createdBy.first_name }} {{ devoir.createdBy.last_name }}</td> -->
                          <td class="name-le" @click="devoir.collapsed = !devoir.collapsed">
                            <span class="news-date">{{ formatDateNews(devoir.created_at) }}</span>
                            à {{ formatTimeNews(devoir.created_at) }}
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <router-link
                                :to="{
                                  name: 'DetailsDM',
                                  params: {
                                    id: devoir.id,
                                  },
                                }"
                                class=""
                              >
                                <i class="icon-eyes"
                                  ><span class="tooltiptext">{{ $t("button.tooltip.details") }}</span></i
                                >
                              </router-link>
                            </div>
                          </td>
                          <!-- <i
                                                                @click.prevent="
                                                                    deleteDevoir(
                                                                        devoir.id
                                                                    )
                                                                "
                                                                class="icon-trash"
                                                            >
                                                                <span
                                                                    class="tooltiptext"
                                                                    >Supprimer</span
                                                                >
                              </i>-->
                          <!-- <router-link
                                                                :to="{
                                                                    name: 'EditDm',
                                                                    params: {
                                                                        id: devoir.id,
                                                                    },
                                                                }"
                                                                class=""
                                                            >
                                                                <i
                                                                    class="icon-edit-02"
                                                                    ><span
                                                                        class="tooltiptext"
                                                                        >Modifier</span
                                                                    ></i
                                                                >
                              </router-link>-->
                          <!-- <div>
                                <i
                                  v-if="!devoir.collapsed"
                                  class="icon-eyes"
                                  @click="devoir.collapsed =!devoir.collapsed"
                                />
                                <i
                                  v-else
                                  class="icon-Show-eye"
                                  @click="devoir.collapsed =!devoir.collapsed"
                                />
                              </div>
                            </div>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div v-if="total > nbPage" class="table__wrapper__pagination-wrapper">
                      <div class="pagination">
                        <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import HomeWorkService from "../../services/home-work.service";
import pagination from "../../components/navigation/Pagination";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {required, maxLength, helpers} from "@vuelidate/validators";
import moment from "moment";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import {mapGetters} from "vuex";
export default {
  name: "DevoirList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: false,
      search: true,
      devoirs: [],
      selected: [],
      total: 0,
      totalTermine: 0,
      totalEnCours: 0,
      pagination: {},
      currentPage: 1,
      totalRows: 1,
      showFil: false,
      students: [],
      nbPage: 20,
      params: {
        q: "",
        limit: null,
        page: 1,
        sort: "due_date",
        class_school_id: [],
        course_id: [],
        class_ids: "",
        class_type_id: null,
        order: false,
      },
      selectedLevel: null,
      selectedClass: null,
      last_page: null,
      selectedCourse: null,
      classes: [],
      courses: [],
      levels: [],
      moment: null,
      createdFirstName: "",
      createdLastName: "",
      passageYears: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    /*  selectAll: {
      get: function () {
        return this.devoirs ? this.selected.length == this.devoirs.length : false;
      },
      set: function (value) {
        let selected = [];

        if (value) {
          this.devoirs.forEach(function (user) {
            selected.push(user.id);
          });
        }

        this.selected = selected;
      },
    }, */
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.selectedLevel = [];
        this.params.class_type_id = [];
        this.selectedClass = null;
        this.params.class_school_id = [];
        this.selectedCourse = null;
        this.params.course_id = [];
        this.passageYears = val.id;
        this.ListHomeWorks();
      }
    },
  },
  created() {
    this.moment = moment;
    this.params.limit = this.nbPage;
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.ListHomeWorks();
    }
  },

  methods: {
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListHomeWorks();
    },
    formatTimeNews(date) {
      return moment.utc(date).format("HH:mm");
    },
    formatDateNews(date) {
      moment.locale("fr");
      return moment(date).format("DD-MM-YYYY");
    },
    studentDM(devoir) {
      if (!devoir) return false;
      if (devoir.homework_type === "1") {
        let endFullName = devoir.students_list.length > 1 ? ",..." : "";
        return devoir.students_list[0]?.last_name + " " + devoir.students_list[0]?.first_name + endFullName;
      } else {
        return devoir.class.name;
      }
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    resetFilter() {
      this.selectedLevel = [];
      this.params.class_type_id = [];
      this.selectedClass = null;
      this.params.class_school_id = [];
      this.selectedCourse = null;
      this.params.course_id = [];
      this.FilterHomeWorks();
      this.getResults();
    },

    showFilter() {
      this.showFil = !this.showFil;
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListHomeWorks();
    }, 200),
    ListHomeWorks() {
      this.loading = true;
      HomeWorkService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_school_id,
          course_id: this.params.course_id,
          class_type_id: this.params.class_type_id,
          school_year: this.passageYears,
        },
      }).then(
        (response) => {
          this.FilterHomeWorks();
          this.devoirs = response.data.data;
          if (response.data.completed_home_work !== null) {
            this.totalTermine = response.data.completed_home_work;
          } else {
            this.totalTermine = 0;
          }

          if(this.devoirs.length){
            this.devoirs.forEach(function (item) {
              item.collapsed = false;
            });
            this.createdFirstName = this.devoirs[0].createdBy.first_name;
            this.createdLastName = this.devoirs[0].createdBy.last_name;
          }

          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
        },
        (error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push("/error-403");
          }
          console.error(error);
        }
      );
    },
    getStats() {
      HomeWorkService.getStat({
        params: {
          type_id: this.params.class_type_id,
          class_school_id: this.params.class_school_id,
          course_id: this.params.course_id,
        },
      })
        .then((response) => {})
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    FilterHomeWorks() {
      this.loading = true;
      //this.classes = [];
      this.courses = [];
      this.devoirs = [];
      HomeWorkService.getFilterDev({
        params: {
          // type_id: this.params.class_type_id,
          class_type_id: this.params.class_type_id,
          course_id: this.params.course_id,
          class_school_id: this.params.class_school_id,
          school_year: this.passageYears,
        },
      })
        .then((response) => {
          this.getStats();
          this.levels = response.data.types;
          /*    this.classes = _.orderBy(response.data.types.classe, "name");
          this.courses = _.orderBy(response.data.types.classe.courses, "name");
           */
        })
        .catch((error) => {
          console.error(error);
        });
    },

    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null) {
      this.selected = [];

      this.params.page = !page ? this.params.page : page;
      this.loading = true;
      HomeWorkService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_school_id,
          course_id: this.params.course_id,
          class_type_id: this.params.class_type_id,
          school_year: this.passageYears,
        },
      })
        .then(
          (response) => {
            this.devoirs = response.data.data;
            if (response.data.completed_home_work !== null) {
              this.totalTermine = response.data.completed_home_work;
            } else {
              this.totalTermine = 0;
            }

            this.pagination = this.makePagination(response.data.meta, response.data.links);
            this.total = response.data.meta.total;
            this.getStats();
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },

    ChangeClass(e) {
      this.selectedCourse = null;
      this.params.course_id = [];
      if (e != null) {
        this.params.class_school_id = [];
        this.params.class_school_id = e.id;

        this.courses = _.orderBy(e.courses, "name");
      } else {
        this.params.class_school_id = [];
      }

      this.getResults();
    },
    // ChangeClass(e) {
    //   if (e != null) {
    //     // this.params.class_ids = "";
    //     this.params.class_school_id = [];
    //     this.params.class_school_id = e;
    //   } else {
    //     this.params.class_school_id = [];
    //   }

    //   this.getResults();
    // },
    ChangeCourse(e) {
      if (e != null && e.length !== 0) {
        this.params.course_id = Object.entries(e).map(([key, value]) => value.id);
      } else {
        this.params.course_id = [];

        this.selectedCourse = null;
      }

      this.getResults();
    },

    ChangeLevel(e) {
      if (e != null) {
        this.courses = [];

        this.params.class_type_id = e.id;
        /*  if (e[e.length - 1]) this.classes = [...this.classes, ..._.orderBy(e[e.length - 1].classe, "name")];
        this.classes = Array.from(new Set(this.classes.filter((object) => this.params.class_type_id.includes(object.class_type_id))));*/
      } else {
        this.params.class_type_id = null;

        this.selectedLevel = null;
      }
      // this.params.class_type_id = [];
      this.params.course_id = [];
      this.selectedClass = null;
      this.selectedCourse = null;
      this.params.class_school_id = [];
      this.params.page = 1;
      //  this.FilterHomeWorks();
      if (e) {
        this.classes = _.orderBy(e?.classe, "name");
        this.courses = _.orderBy(e.classe?.courses, "name");
      }
      this.getResults();
    },
    deleteDevoir(id) {
      // eslint-disable-next-line no-undef
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const index = this.devoirs.findIndex((items) => items.id === id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteDevoir"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.devoirDeleted"), "", "success");
            HomeWorkService.delete(id);
            this.devoirs.splice(index, 1);
          }
        });
    },
    deleteSelected() {
      // eslint-disable-next-line no-undef
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSelectedDevoir"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.devoirSelectedDeleted"), "", "success");
            HomeWorkService.deleteAll({
              params: {
                homoworksId: this.selected,
              },
            }).then(
              () => {
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },

    searshDevoir: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListHomeWorks();
      }
    }, 200),
  },
};
</script>
<style scoped>
.text-message {
  text-align: left;
}
.arabic-text {
  text-align: right;
}
td.name-description.text-message {
  word-wrap: break-word;
  max-width: 150px;
}
</style>
